import ExperimentsTable from './ExperimentsTable';

export default ExperimentsTable;
